import { useSyncExternalStore } from 'react';
import {
  getSettingsEntryProduct,
  subscribeSettingsEntryProduct,
  type SettingsEntryProduct,
} from '../lib/productSurfacePaths';

/** Reactive read of which product mode opened the shared Settings hub. */
export function useSettingsEntryProduct(): SettingsEntryProduct | null {
  return useSyncExternalStore(
    subscribeSettingsEntryProduct,
    getSettingsEntryProduct,
    () => null,
  );
}
